module.exports = __webpack_public_path__ + "static/media/roku.3fe47763.png";